/* eslint-disable react-hooks/exhaustive-deps */
import {SelectButton} from 'primereact/selectbutton'
import {
    forwardRef,
    useCallback,
    useImperativeHandle,
    useMemo,
    useState,
} from 'react'
import FlexBox from '../layout/FlexBox'

const SelectButtonUtils = forwardRef(
    (
        {
            optionsList = [],
            onChangeKey = '',
            multiple = false,
            defaultValue,
            icon = false,
            iconLabel = '',
            patient = false,
            onChangeValue = () => {},
        },
        ref,
    ) => {
        useImperativeHandle(ref, () => ({
            value: value,
        }))
        const redList = [
            'voice',
            'pain',
            'unresponsive',
            'confusion',
            'nasal',
            'simpleMask',
            true,
            7,
            8,
            9,
            10,
        ]
        const yellowList = [4, 5, 6]
        const [value, setValue] = useState(defaultValue)
        const handleOnChange = useCallback(
            e => {
                setValue(e.value)
                onChangeValue(onChangeKey, e.value)
            },
            [onChangeKey, onChangeValue],
        )
        const justifyTemplate = (option, index) => {
            if (icon) {
                return (
                    <FlexBox className={'flex-column'}>
                        <div>
                            <img
                                className="h-2rem"
                                alt={option.value}
                                src={option.icon}
                            />
                        </div>
                        <div>
                            <span className="font-bold">{option.value}</span>
                        </div>
                    </FlexBox>
                )
            } else {
                return option.label
            }
        }

        const idColor = useMemo(() => {
            return !patient
                ? redList.includes(value)
                    ? 'red'
                    : yellowList.includes(value)
                    ? 'yellow'
                    : ''
                : ''
        }, [patient, redList, yellowList, value])
        return (
            <SelectButton
                className="grid col-12 px-0 mb-3"
                id={idColor}
                itemTemplate={justifyTemplate}
                value={value}
                options={optionsList}
                onChange={handleOnChange}
                optionLabel="label"
                multiple={multiple}
            />
        )
    },
)

export default SelectButtonUtils
